<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>询价单</el-breadcrumb-item>
    </el-breadcrumb>
    <order-list :deleted="0" :status="100" :consult="true"></order-list>
  </div>
</template>

<script>
import OrderList from './list'
export default {
  components: { OrderList },
}
</script>